export default "__VITE_ASSET__D$FKAOzn__"